import { Command } from '@/app/common/base/command'
import { EmailOtpResponse } from '@/app/auth/entities/email-otp-response.entity'

export class SendEmailOtpCommand extends Command {
    public async run(consumerId?: string): Promise<EmailOtpResponse> {
        const response = await this.client.post('/api/auth/two-factor-email-send', {
            consumerId
        })
        return response.asEntity(EmailOtpResponse)
    }
}
